// Copyright (c) Ping. All rights reserved.
//
// Web variant of the Archive glyph used by the conversation-list Archive tab
// (Figma design-system archive icon, supplied verbatim). react-native-svg has
// no web runtime, so the parametrised SVG is encoded as a
// `data:image/svg+xml;…` URI fed to `<Image>`; macOS uses the `.macos.tsx`
// sibling via `SvgXml`. Mirrors `MessagePreviewIcon.tsx`.

import { Image } from 'react-native';

// `__COLOR__` is substituted for the active stroke colour. Full-bounds mask /
// clip wrappers from the export are dropped (no-ops over the 24×24 viewBox).
function svg(color: string): string {
  const c = color;
  return `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"><path d="M19.5 10.2207V19.0007C19.5 21.0007 19 22.0007 16.5 22.0007H7.5C5 22.0007 4.5 21.0007 4.5 19.0007V10.2207" stroke="${c}" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/><path d="M5 2H19C21 2 22 3 22 5V7C22 9 21 10 19 10H5C3 10 2 9 2 7V5C2 3 3 2 5 2Z" stroke="${c}" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/><path d="M10.1801 14H13.8201" stroke="${c}" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>`;
}

export interface ArchiveGlyphProps {
  readonly size?: number;
  readonly color: string;
  readonly accessibilityLabel?: string;
}

export function ArchiveGlyph({
  size = 16,
  color,
  accessibilityLabel,
}: ArchiveGlyphProps): JSX.Element {
  const xml = svg(color);
  const uri =
    typeof btoa !== 'undefined'
      ? `data:image/svg+xml;base64,${btoa(xml)}`
      : `data:image/svg+xml;utf8,${encodeURIComponent(xml)}`;
  return (
    <Image
      source={{ uri }}
      accessibilityIgnoresInvertColors
      accessibilityLabel={accessibilityLabel ?? 'Archive'}
      style={{ width: size, height: size }}
      resizeMode="contain"
    />
  );
}
